import PaperCheckModule from './paperCheckContainer';
import {isMobile} from 'Utils/device';

const PaperCheckModuleFn = isMobile ? null : PaperCheckModule;
export default PaperCheckModuleFn;
